/**
 * CPG canonical mega-menu (task #14) — behavior. Desktop-only 3-column panel
 * (mockup screen 21): LEVEL 1 department → LEVEL 2 subcategory → LEVEL 3 detail.
 * Hovering/clicking a department swaps the subcategory column and auto-selects its
 * first subcategory; hovering/clicking a subcategory repaints the L3 detail pane.
 * Also: click-to-open, and the per-vehicle L1 "N fit" overlay from
 * /storefront/fitment/category-counts (degrades to totals-only with no vehicle /
 * before #15 deploys). Markup + CSS: snippets/cpg-mega-menu.liquid.
 */
(function () {
  'use strict';
  var API_BASE_FALLBACK = 'https://carpartglobal-api-743237931312.us-central1.run.app/storefront/fitment';

  function apiBase(root) {
    var attr = root && root.getAttribute('data-cpg-api-base');
    if (attr) return attr;
    var host = document.querySelector('[data-cpg-ymm-widget][data-cpg-api-base]');
    return (host && host.getAttribute('data-cpg-api-base')) || API_BASE_FALLBACK;
  }
  function readVehicle() {
    try {
      if (window.CPGFitment && typeof CPGFitment.getVehicle === 'function') return CPGFitment.getVehicle();
      var raw = localStorage.getItem('cpg:garage:vehicle');
      var v = raw ? JSON.parse(raw) : null;
      return v && v.year && v.make && v.model ? v : null;
    } catch (e) { return null; }
  }
  function fmt(n) { try { return Number(n).toLocaleString('en-US'); } catch (e) { return String(n); } }

  function init(root) {
    if (root.__cpgMmInit) return; root.__cpgMmInit = true;
    var trigger = root.querySelector('[data-cpg-mm-trigger]');
    var panel = root.querySelector('[data-cpg-mm-panel]');
    var l1s = Array.prototype.slice.call(root.querySelectorAll('[data-cpg-l1]'));
    var l2s = Array.prototype.slice.call(root.querySelectorAll('[data-cpg-l2]'));
    var closers = root.querySelectorAll('[data-cpg-mm-close]');
    if (!trigger || !panel) return;

    // v5.2: brand ?vendors= cards ship as JSON (not crawlable page HTML) and are built
    // here only when a subcategory is hovered → they never enter Googlebot's crawled DOM.
    var _footData = null;
    function footData() {
      if (_footData) return _footData;
      var el = root.querySelector('[data-cpg-mm-footdata]');
      try { _footData = el ? JSON.parse(el.textContent) : {}; } catch (e) { _footData = {}; }
      return _footData;
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function buildFoot(key) {
      var host = root.querySelector('[data-cpg-mm-brands="' + key + '"]');
      if (!host || host.getAttribute('data-built')) return;
      host.setAttribute('data-built', '1');
      var d = footData()[key];
      if (!d || !d.b || !d.b.length) return;
      var base = d.u || '/collections', html = '';
      for (var i = 0; i < d.b.length; i++) {
        var b = d.b[i], plate = esc((b.n || '').charAt(0));
        html += '<a class="cpg-mm__brandcard" href="' + esc(base) + '?vendors=' + encodeURIComponent(b.n) + '">'
          + '<span class="cpg-mm__brandcard-plate">' + plate + '</span>'
          + '<span class="cpg-mm__brandcard-t"><span class="cpg-mm__brandcard-lbl">Top brand</span><b>' + esc(b.n) + '</b><em>' + esc(b.c) + ' parts</em></span>'
          + '</a>';
      }
      host.innerHTML = html;
    }

    function activateL2(key) {
      l2s.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cpg-l2') === key); });
      root.querySelectorAll('[data-cpg-l3panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cpg-l3panel') === key);
      });
      root.querySelectorAll('[data-cpg-l3footer]').forEach(function (p) {
        var on = p.getAttribute('data-cpg-l3footer') === key;
        p.classList.toggle('is-active', on);
        if (on) buildFoot(key);
      });
    }
    function activateL1(slug) {
      l1s.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cpg-l1') === slug); });
      root.querySelectorAll('[data-cpg-l2panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cpg-l2panel') === slug);
      });
      var p2 = root.querySelector('[data-cpg-l2panel="' + slug + '"]');
      var firstL2 = p2 ? p2.querySelector('[data-cpg-l2]') : null;
      if (firstL2) activateL2(firstL2.getAttribute('data-cpg-l2'));
    }

    function open() {
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      paint();
      if (l1s.length && !root.querySelector('[data-cpg-l1].is-active')) activateL1(l1s[0].getAttribute('data-cpg-l1'));
    }
    function close() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    }
    trigger.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); root.classList.contains('is-open') ? close() : open(); });
    closers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); close(); }); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    l1s.forEach(function (b) {
      var slug = b.getAttribute('data-cpg-l1');
      b.addEventListener('mouseenter', function () { activateL1(slug); });
      b.addEventListener('click', function () { activateL1(slug); });
    });
    l2s.forEach(function (b) {
      var key = b.getAttribute('data-cpg-l2');
      b.addEventListener('mouseenter', function () { activateL2(key); });
      b.addEventListener('click', function () { activateL2(key); });
    });

    // ── per-vehicle L1 "N fit" overlay ──────────────────────────────────────
    var lastKey = null;
    function paint() {
      var v = readVehicle();
      var badges = root.querySelectorAll('[data-cat-slug]');
      if (!v) { badges.forEach(function (b) { b.hidden = true; b.textContent = ''; }); lastKey = null; return; }
      var key = [v.year, v.make, v.model].join('|');
      if (key === lastKey) return;
      lastKey = key;
      var qs = 'year=' + encodeURIComponent(v.year) + '&make=' + encodeURIComponent(v.make) + '&model=' + encodeURIComponent(v.model);
      fetch(apiBase(root) + '/category-counts?' + qs)
        .then(function (r) { return r.ok ? r.json() : { counts: {} }; })
        .then(function (d) {
          var counts = (d && d.counts) || {};
          badges.forEach(function (b) {
            var n = counts[b.getAttribute('data-cat-slug')] || 0;
            if (n > 0) { b.textContent = fmt(n) + ' fit'; b.hidden = false; } else { b.textContent = ''; b.hidden = true; }
          });
        }).catch(function () {});
    }
    window.addEventListener('cpg:vehicle-changed', function () { lastKey = null; paint(); });
    window.addEventListener('storage', function (e) { if (e.key === 'cpg:garage:vehicle') { lastKey = null; paint(); } });
    paint();
  }

  // The panel ships inside <template data-cpg-mm-tpl> so it costs no live DOM nodes
  // until it is needed. Clone it in, replacing the template element in place so the
  // panel keeps its position inside .cpg-mm__bar-inner (it is absolutely positioned
  // against it). Returns false if this root was already hydrated.
  function hydrate(root) {
    var tpl = root.querySelector('template[data-cpg-mm-tpl]');
    if (!tpl) return false;
    tpl.parentNode.replaceChild(tpl.content.cloneNode(true), tpl);
    return true;
  }

  function boot() {
    document.querySelectorAll('[data-cpg-mm]').forEach(function (root) {
      var trigger = root.querySelector('[data-cpg-mm-trigger]');
      // No trigger (or no template) -> nothing to defer, behave exactly as before.
      if (!trigger || !root.querySelector('template[data-cpg-mm-tpl]')) { init(root); return; }

      var started = false;
      function start(e) {
        if (started) return;
        started = true;
        hydrate(root);
        init(root);
        // init() binds its own click handler on the trigger, but a listener added while
        // this same click is being dispatched does NOT receive it — so the first click
        // would otherwise hydrate and then do nothing. Open it here.
        if (e && e.type === 'click') {
          e.preventDefault();
          e.stopPropagation();
          root.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          var p = root.querySelector('[data-cpg-mm-panel]');
          if (p) p.setAttribute('aria-hidden', 'false');
        }
      }
      // mouseenter/focus cover desktop hover + keyboard; click covers touch.
      trigger.addEventListener('mouseenter', start);
      trigger.addEventListener('focus', start);
      trigger.addEventListener('click', start);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
